import { Route } from 'vue-router';

export function inheritedMeta(to: Route): any {
  return to.matched.reduce((meta, item) => Object.assign(meta, item.meta), {});
}
